import { render, staticRenderFns } from "./OrderCreateDialog.vue?vue&type=template&id=25d8323d"
import script from "./OrderCreateDialog.vue?vue&type=script&lang=js"
export * from "./OrderCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderCreateDialog.vue?vue&type=style&index=0&id=25d8323d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports